module.exports = __webpack_public_path__ + "assets/img/everyday_bottom_ok.898f3ced.png";